import { ref, reactive } from 'vue';
import "ant-design-vue/es/message/style/css";
import _message from "ant-design-vue/es/message";
//import dayjs from 'dayjs';
import { Post, Get } from '@/api/Api';
import { ls } from 'vue-lsp';
import { GetBaseUrl } from '@/utils/request';
import { ACCESS_TOKEN } from '@/store/mutation-types';
export default {
  name: 'Index',
  components: {},
  setup(props, context) {
    const RefForm = ref();
    const IsShow = ref(false);
    const DMConfig = reactive({
      FId: 0,
      Title: '',
      Width: '0',
      Height: '0',
      loading: false,
      ModelClass: '',
      Model: {},
      TypeList: [],
      DMForm: {
        form: {
          labelCol: {
            style: {
              width: '80px'
            }
          }
        }
      },
      headers: {
        authorization: 'Bearer ' + ls.get(ACCESS_TOKEN)
      },
      uploadurl: GetBaseUrl() + '/api/UploadDistributorInfo'
    });
    const SubmitForm = e => {
      RefForm.value.validate().then(() => {
        console.log('values11', DMConfig.Model);
        DMConfig.Model.fBeginDate = new Date(DMConfig.Model.fBeginDate).toISOString();
        DMConfig.Model.fEndDate = new Date(DMConfig.Model.fEndDate).toISOString();
        console.log('values11', DMConfig.Model);
        //new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString(); 
        DMConfig.loading = true;
        Post("DM/SaveDistributorInfo", DMConfig.Model).then(res => {
          if (res.succeeded) {
            _message.success('保存成功');
            context.emit('ok');
            IsShow.value = false;
          } else {
            _message.error('保存失败：' + res.errors);
            DMConfig.loading = false;
          }
        }).catch(err => {
          _message.error(err.errors);
          DMConfig.loading = false;
        });
      }).catch(error => {
        console.log(error);
        //message.error(error.message);
      });
    };

    const ResetForm = (form, DataSource) => {
      console.log('DataSource');
    };
    const Open = (fId, width, height) => {
      IsShow.value = true;
      DMConfig.loading = true;
      DMConfig.FId = fId;
      DMConfig.Title = (fId == 0 ? '新增' : '修改') + '客户';
      DMConfig.Width = width == 0 ? "100%" : width;
      DMConfig.ModelClass = width == 0 ? "full-modal" : "";
      DMConfig.Height = height == 0 ? "100%" : height;
      Get("/DM/DistributorInfoClassList", null).then(res => {
        DMConfig.TypeList = res.data.rows;
        console.log(DMConfig.TypeList);
      });
      if (fId > 0) {
        Get("/DM/GetDistributorInfo", {
          id: fId
        }).then(res => {
          DMConfig.Model = res.data;
          DMConfig.loading = false;
        });
      } else {
        DMConfig.Model = {};
        DMConfig.loading = false;
      }
    };
    const OnUploadChange = info => {
      console.log(info);
      DMConfig.Model.fFileName = "";
      DMConfig.Model.fFilePath = "";
      if (info.file.status !== 'uploading') {
        DMConfig.Model.fFilePath = info.file.response.data.fileName;
        DMConfig.Model.fFileName = info.file.name;
        console.log(info.file);
      }
      if (info.file.status === 'done') {
        _message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        _message.error(`${info.file.name} file upload failed.`);
      }
    };
    const OnBeforeUpload = file => {
      // const isJPG = file.type === 'image/jpeg';
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      const extension = testmsg === 'pdf';
      const extension2 = testmsg === 'pdf';
      //const isLt2M = file.size / 1024 / 1024 < 2;
      const isLt2M = true;
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!extension && !extension2) {
        _message.error('Upload file can only be pdf format!');
        return false;
      }
      if (!isLt2M) {
        _message.error('上传大小不能超过 2MB!');
      }
      // return isJPG && isLt2M;
      return (extension || extension2) && isLt2M;
    };
    return {
      IsShow,
      Open,
      RefForm,
      DMConfig,
      SubmitForm,
      ResetForm,
      OnUploadChange,
      OnBeforeUpload
    };
  },
  created() {
    console.log('created');
  },
  mounted() {},
  methods: {}
};